import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=3c1dc0bb&scoped=true"
import script from "./grant.vue?vue&type=script&lang=js"
export * from "./grant.vue?vue&type=script&lang=js"
import style0 from "./grant.vue?vue&type=style&index=0&id=3c1dc0bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1dc0bb",
  null
  
)

export default component.exports